function errorHandler(error){
const modalInfo= {type: "error" , message: "", code: null }

if(error instanceof TypeError){
    modalInfo.message = "Error de conexión. Inténtelo de nuevo más tarde o contacte con el administrador."
} else {

    modalInfo.code = error.code
    switch(error.code){
        case 400:
        case 409:
            modalInfo.type = "warning"
            modalInfo.message = error.message
            break;
        case 401:
            modalInfo.type= "warning";
            modalInfo.message = "Erro de autenticação. Insira novamente suas credenciais.";
            break;
        case 403:
            modalInfo.type = "warning";
            modalInfo.message = "Operação não realizada: O usuário não possui permissão para realizar esta operação."
            break;
        case 500: 
             modalInfo.message = "Ocorreu um erro inesperado. Por favor entre em contato com o administrador.";
            break;
         default:
            modalInfo.message = "Ocorreu um erro inesperado. Por favor entre em contato com o administrador.";
            break;
}
}

return modalInfo

}

export {errorHandler}